
function askPelletsStyle (style) {
  const roundDouble = style === 'roundDouble'
  const incidenceDouble = style === 'incidenceDouble'

  return {
    round: style === 'round',
    roundDouble: roundDouble,
    incidence: style === 'incidence',
    incidenceDouble: incidenceDouble,
    twoValues: roundDouble || incidenceDouble
  }
}

export default {
  askPelletsStyle
}
